import { useQuery } from 'react-query';
import { axiosInstance } from '../../config/axios';

interface IksTerminalRequestFilter {
  field: string;
  values: string[];
  valueType: number;
  operationType: number;
}

interface GetIksTerminalRequestsPayload {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
  status?: string;
  filters?: IksTerminalRequestFilter[];
}

export interface IksTerminalRequest {
  id: number;
  merchantId: number;
  bankCode: string;
  bankName?: string; // Optional: To be added in the component
  referenceCode: string;
  status: string;
  responseCode: string | null;
  responseCodeExplanation: string | null;
}

interface PagingResponse<T> {
  result: T[];
  totalItems: number;
  page: number;
  size: number;
}

const getIksTerminalRequests = async (payload: GetIksTerminalRequestsPayload): Promise<PagingResponse<IksTerminalRequest>> => {
  const response = await axiosInstance.post('/MerchantIKS/GetIKSTerminalRequests', payload);
  return response.data;
};

export const useGetIksTerminalRequests = (payload: GetIksTerminalRequestsPayload, options?: any) => {
  return useQuery<PagingResponse<IksTerminalRequest>>(
    ['iksTerminalRequests', payload],
    () => getIksTerminalRequests(payload),
    options
  );
};
